import type { RouteRecordRaw } from 'vue-router';
import landingSeoSpokes from '@jaaluu/data/landingSeoSpokes.json';
import type { CourseLang, LandingGroup, LandingLang, SpokeSeoEntry } from '@jaaluu/composables/useLandingSeo';

const SpokeLandingPage = () => import('@jaaluu/views/Landing/SpokeLandingPage.vue');

type LandingSeoSpokes = Record<
  LandingGroup,
  Partial<Record<LandingLang, Partial<Record<CourseLang, SpokeSeoEntry>>>>
>;
const SPOKE_CONTENT = landingSeoSpokes as unknown as LandingSeoSpokes;

// Generates the ~576-page spoke route table from data instead of hand-typing
// each route object the way the 81 hub routes in router/index.ts are - every
// entry lazy-imports the SAME shared SpokeLandingPage.vue (one chunk, not
// one per route), differentiated only by route meta.
export const generateSpokeRoutes = (): RouteRecordRaw[] => {
  const routes: RouteRecordRaw[] = [];

  for (const [group, uiLangs] of Object.entries(SPOKE_CONTENT) as [LandingGroup, LandingSeoSpokes[LandingGroup]][]) {
    for (const [uiLang, targets] of Object.entries(uiLangs) as [LandingLang, Partial<Record<CourseLang, SpokeSeoEntry>>][]) {
      for (const [targetLang, spokeEntry] of Object.entries(targets) as [CourseLang, SpokeSeoEntry][]) {
        routes.push({
          path: `/${spokeEntry.path}`,
          name: `spoke-${group}-${uiLang}-${targetLang}`,
          component: SpokeLandingPage,
          meta: { group, uiLang, targetLang }
        });
      }
    }
  }

  return routes;
};
